import "./breadcrumbs.scss";
import React from "react";
import { Link } from "gatsby";

const Breadcrumbs = ({
  location,
  crumbFirstLabel,
  crumbFirstLink,
  crumbSecondLabel,
  crumbSecondLink,
}) => {
  return (
    <div className="breadcrumbs">
      <Link to="/" className="breadcrumbs__home-link">
        elcamp.pl
      </Link>
      <span className="breadcrumbs__separator"> › </span>
      {crumbFirstLabel && (
        <>
          <Link to={crumbFirstLink} className="breadcrumbs__page">
            {crumbFirstLabel?.toLowerCase()}
          </Link>
          <span className="breadcrumbs__separator"> › </span>
        </>
      )}
      {crumbSecondLabel && (
        <>
          <Link to={crumbSecondLink} className="breadcrumbs__page">
            {crumbSecondLabel?.toLowerCase()}
          </Link>
          <span className="breadcrumbs__separator"> › </span>
        </>
      )}
      <div className="breadcrumbs__page">{location?.toLowerCase()}</div>
    </div>
  );
};

export default Breadcrumbs;
